//https://github.com/ptt/pttbbs/blob/master/include/pttstruct.h#L13
export const MAX_IDLEN = 12
export const MIN_IDLEN = 2
export const MAX_PWLEN = 30
export const MIN_PWLEN = 6

export const GITHUB_LINK = 'https://github.com/Ptt-official-app/demo-pttbbs'

//https://github.com/Ptt-official-app/go-pttbbs/blob/main/ptttype/board_stat.go
export const NBRD_INVALID = 0
export const NBRD_FAV = 1
export const NBRD_BOARD = 2
export const NBRD_LINE = 4
export const NBRD_FOLDER = 8
export const NBRD_TAG = 16
export const NBRD_UNREAD = 32
export const NBRD_SYMBOLIC = 64

//https://github.com/Ptt-official-app/go-openbbsmiddleware/blob/main/types/color.go
export const COLOR_FOREGROUND_BLACK = 30
export const COLOR_FOREGROUND_RED = 31
export const COLOR_FOREGROUND_GREEN = 32
export const COLOR_FOREGROUND_YELLOW = 33
export const COLOR_FOREGROUND_BLUE = 34
export const COLOR_FOREGROUND_MAGENTA = 35
export const COLOR_FOREGROUND_CYAN = 36
export const COLOR_FOREGROUND_WHITE = 37
export const COLOR_BACKGROUND_BLACK = 40
export const COLOR_BACKGROUND_RED = 41
export const COLOR_BACKGROUND_GREEN = 42
export const COLOR_BACKGROUND_YELLOW = 43
export const COLOR_BACKGROUND_BLUE = 44
export const COLOR_BACKGROUND_MAGENTA = 45
export const COLOR_BACKGROUND_CYAN = 46
export const COLOR_BACKGROUND_WHITE = 47

//https://github.com/Ptt-official-app/go-openbbsmiddleware/blob/main/types/comment_type.go
export const COMMENT_TYPE_UNKNOWN = 0
export const COMMENT_TYPE_RECOMMEND = 1
export const COMMENT_TYPE_BOO = 2
export const COMMENT_TYPE_COMMENT = 3
export const COMMENT_TYPE_FORWARD = 4
export const COMMENT_TYPE_REPLY = 5
export const COMMENT_TYPE_EDIT = 6
export const COMMENT_TYPE_DELETED = 7
